import { createContext } from 'react'

import type { TherapistCartContextType } from '@/src/domains/cart/types'

export const TherapistCartContext = createContext<TherapistCartContextType | null>(null)
